import * as React from "react";
import { SnapshotCollectionsTemplates } from "./components/templates";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";
import { SnapshotCollectionsList } from "./components/list";
import { Separator } from "@/components/ui/separator";

export const SnapshotCollections: React.FC = () => {
  const [selectedBusinessReport, setSelectedBusinessReport] = React.useState<BusinessReport | null>(null);

  return (
    <>
      <SnapshotCollectionsTemplates
        selectedBusinessReport={selectedBusinessReport}
        setSelectedBusinessReport={setSelectedBusinessReport}
      />
      <div className="my-5 mt-8">
        <Separator />
      </div>
      {selectedBusinessReport && <SnapshotCollectionsList selectedBusinessReport={selectedBusinessReport} />}
    </>
  );
};
